import React, { useState, useEffect } from "react";
import { PrintDataModel } from "../../../models/policy.model";
import { getActiveUsers, printDiary } from "../../../services/policy.service";
import useStyles from "../../../shared/styles";
import { Button, Menu, MenuItem } from "@material-ui/core";
import { previewPdf } from "../../../shared/FileDownload";
import PrintModal from "../../../popup/PrintModal";
export default function CustomeSettings(props) {
  const { page, pageSize, sortColumn, sortColumnOrder } = props;
  const classes = useStyles();

  // const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElement, setAnchorElement] = useState(null);
  const [formData, setFormData] = useState(PrintDataModel);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [error, setError] = useState({});
  const [payload, setPayload] = useState([
    {
      criteriaName: "userId",
      value: localStorage.getItem("userId"),
    },
    {
      criteriaName: "date",
      value: "",
    },
    {
      criteriaName: "isCleared",
      value: false,
    },
    {
      criteriaName: "isImagingDiaries",
      value: false,
    },
  ]);
  useEffect(() => {
    getUsers();
  }, []);
  const getUsers = () => {
    let array = [];
    getActiveUsers().then(
      (result) => {
        if (result && result.data.statusCode === 200) {
          let user = result.data.response;
          for (let i in user) {
            let obj = {};
            obj.name = user[i];
            obj.value = user[i];
            array.push(obj);
          }
          setUsers(array);
        } else {
        }
      },
      (error) => {},
    );
  };
  const handleSettingInfo = (event) => {
    setAnchorElement(event.currentTarget);
  };

  function handleValidation(data) {
    let err = {};
    let formIsValid = true;
    data.search.forEach((element) => {
      if (element.criteriaName === "date") {
        if (
          element.value === null ||
          element.value === undefined ||
          element.value === ""
        ) {
          formIsValid = false;
          err["date"] = "*required";
        }
      }
    });
    setError(err);
    return formIsValid;
  }

  const printDiaryPdf = () => {
    let array = payload;
    array.forEach((element) => {
      if (element.criteriaName === "userId") {
        element.value = formData.userNameDiary
          ? formData.userNameDiary
          : localStorage.getItem("userId");
      }
      if (element.criteriaName === "date") {
        element.value = formData.date;
      }
      if (element.criteriaName === "isCleared") {
        element.value = formData.showCleared;
      }
      if (element.criteriaName === "isImagingDiaries") {
        element.value = formData.hideImagingDiaries;
      }
    });
    let body = {
      pagination: {
        currentPage: page,
        pageSize: pageSize,
      },
      search: array,
      sort: {
        columnName: sortColumn,
        orderBy: sortColumnOrder,
      },
    };
    if (handleValidation(body)) {
      setIsLoading(true);
      printDiary(body).then(
        (result) => {
          setIsLoading(false);
          setOpen(false);
          previewPdf(result.data);
        },
        (error) => {
          setIsLoading(false);
        },
      );
    }
  };
  const openSettings = (type) => {
    switch (type) {
      case "Print":
        setOpen(true);
        // setAnchorEl(null);
        setAnchorElement(null);
        setFormData({});
        setError({});
        break;

      default:
        break;
    }
  };
  const handleChange = (e, type) => {
    if (type === "date") {
      setFormData({
        ...formData,
        [e.name]: e.value,
      });
    } else {
      e.persist();
      let value =
        e.target.type === "checkbox" ? e.target.checked : e.target.value;
      setFormData({
        ...formData,
        [e.target.name]: value,
      });
    }
  };
  const handleSubmit = () => {
    printDiaryPdf();
  };
  const handleClose = () => {
    setOpen(false);
    setAnchorElement(false);
  };

  return (
    <div>
      <div className="row">
        <Menu
          id="settingDropDown"
          anchorEl={anchorElement}
          keepMounted
          open={Boolean(anchorElement)}
          onClose={handleClose}
          classes={{ paper: classes.menuPopup }}
        >
          <MenuItem
            key={2}
            className={"menuItem"}
            onClick={() => openSettings("Print")}
          >
            {"Print"}
          </MenuItem>
        </Menu>
      </div>
      <PrintModal
        open={open}
        closeModal={handleClose}
        formData={formData}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        isLoading={isLoading}
        users={users}
        errorObject={error}
      />
      <Button
        variant="outlined"
        color="primary"
        className="float-button"
        onClick={handleSettingInfo}
      >
        {" "}
        Print{" "}
      </Button>

      {/* <Fab
        color="primary"
        aria-label="add"
        onClick={handleSettingInfo}
        className="float-button"
      >
        <Settings />
      </Fab> */}
    </div>
  );
}
